import {
    EmailLink,
    StyledLinkText,
} from "./ProvideFeedback.styles";
import React, { useState } from "react";

import { COLOR_VALUES } from "shared/config/colors";
import HStack from "shared/components/layout/stack/HStack";
import PropTypes from "prop-types";
import Text from "shared/components/data-display/text/Text";
import Tooltip from "shared/components/utils/tooltip/Tooltip";
import VStack from "shared/components/layout/stack/VStack";
import env from "react-dotenv";

const TooltipText = ({ label }) => {
    const [copy, setCopy] = useState("Copy email");

    const copyToClipboard = () => {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(env.POWERBI_EMAIL);
            setCopy("Copied to clipboard");
        }
    };
    return (
        <Tooltip text={copy} enterDelay={0} placement="bottom-start">
            <div>
                <StyledLinkText
                    onClick={() => {
                        copyToClipboard();
                    }}
                >
                    {label}
                </StyledLinkText>
            </div>
        </Tooltip>
    )
}

TooltipText.propTypes = {
    label: PropTypes.string,
};

const ProvideFeedback = ({ title, description, linkText, link, label }) => {
    return (
        <VStack style={{ paddingTop: "32px" }}>
                <HStack
                    style={{
                        background: `${COLOR_VALUES.Gray_1}`,
                        padding: "32px",
                    }}
                >
                    <VStack spacing="Zero_5">
                        {title && (
                            <Text variant="Headline_2" color="Gray_8">
                                {title}
                            </Text>
                        )}
                        {description && (
                            <Text variant="Body_2_1" color="Gray_8">
                                {description}
                            </Text>
                        )}
                        {link && (
                            <EmailLink href={`mailto:${link}`}>
                                {linkText}
                            </EmailLink>
                        )}
                        {label && (
                            <TooltipText label={label} />
                        )}
                    </VStack>
                </HStack>
        </VStack>
    );
};

ProvideFeedback.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    link: PropTypes.string,
    label: PropTypes.string,
    linkText: PropTypes.string,
};

export default ProvideFeedback;
